import { render } from "./AdmCadProdutoView.vue?vue&type=template&id=964eb0bc"
import script from "./AdmCadProdutoView.vue?vue&type=script&lang=js"
export * from "./AdmCadProdutoView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__